export default __webpack_public_path__ + "fee66e712a8a08eef5805a46892932ad.woff";